import { defineMessages } from 'react-intl'

const scope = 'app.components.LocationsSection'

export default defineMessages({
  locations: {
    id: `${scope}.locations`,
    defaultMessage: 'Business Locations',
  },
  addresses: {
    id: `${scope}.addresses`,
    defaultMessage: '{count} Addresses',
  },
})
